// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import AccountCreationFormState from "@store/Framework/Store/Store/Components/AccountCreationForm/AccountCreationFormState";
import { Draft } from "immer";

const initialState: AccountCreationFormState = {
    fieldValues: {},
};

const actions = {
    "Components/AccountCreationForm/ClearForm": (draft: Draft<AccountCreationFormState>) => {
        draft.fieldValues = {};
    },
    "Components/AccountCreationForm/SetFieldValue": (
        draft: Draft<AccountCreationFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type AccountCreationFormActions = Parameters<typeof reducer>[1];
export default reducer;
